import clsx from 'clsx'
import { ComponentProps } from 'react'
import { Scroll } from '@criteria-labs/react'

export function InspectorArticle({ className, children, ...props }: ComponentProps<'article'>) {
  return (
    <article className={clsx(className, 'h-full')} {...props}>
      <Scroll>
        <div className="pb-24 pt-3">{children}</div>
      </Scroll>
    </article>
  )
}

export function InspectorHeader({ className, ...props }: ComponentProps<'header'>) {
  return <header className={clsx(className, 'px-6')} {...props} />
}

export function InspectorBody({ className, split, ...props }: { split?: boolean } & ComponentProps<'div'>) {
  return <div className={clsx(className, 'px-6', split && 'grid grid-cols-1 gap-12 sm:grid-cols-3')} {...props} />
}

export function InspectorPrimaryContent({ className, ...props }: ComponentProps<'div'>) {
  return <div className={clsx(className, 'col-span-2')} {...props} />
}

export function InspectorSecondaryContent({ className, ...props }: ComponentProps<'div'>) {
  return <div className={clsx(className, 'col-span-1')} {...props} />
}
